export default [
  {
    path: 'jurisdictions',
    name: 'JurisdictionsList',
    component: () => import('@/app/jurisdiction/views/JurisdictionsList.vue')
  },
  {
    path: 'jurisdictions/new',
    name: 'NewJurisdiction',
    component: () => import('@/app/jurisdiction/views/NewJurisdiction.vue')
  },
  {
    path: 'jurisdictions/:id',
    name: 'JurisdictionDetail',
    component: () => import('@/app/jurisdiction/views/JurisdictionDetail.vue')
  },
];
